import { render, staticRenderFns } from "./SettingTemplateDiyPamras.vue?vue&type=template&id=1e298803&"
import script from "./SettingTemplateDiyPamras.vue?vue&type=script&lang=ts&"
export * from "./SettingTemplateDiyPamras.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports